// extracted by mini-css-extract-plugin
export default {"container":"InvoiceGameDetail_container__mp-D0","tables":"InvoiceGameDetail_tables__bHNxm","info_text":"InvoiceGameDetail_info_text__gyvF4"};